/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener('rebuy:cart.change', (event) => { 
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          if(cart.item_count == 0){
            $(".cart__toggle").removeClass("cart__toggle--has-items");
          }
        }
    });
  });

  $('.selector-wrapper--qty .select-popout__toggle').click(function(){
    $(this).parent().find('.select-popout__list').toggleClass('select-popout__list--visible');
  });
  $('.selector-wrapper--qty .select-popout__option').click(function(){
    var v = $(this).data('value');
    $(this).parents('.select-popout').find('.select-popout__value').text(v);
    $(this).parents('.select-popout').find('[data-popout-input]').val(v);
    $(this).parents('.select-popout').find('.select-popout__list').removeClass('select-popout__list--visible');
  });
})();
